module.exports = __webpack_public_path__ + "static/media/good_job_you_are_fighting_the_cavity_monsters.2ad4875.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/good_job_you_are_fighting_the_cavity_monsters.mp3
// module id = 73oa
// module chunks = 0